import bgLocale from 'dayjs/locale/bg';
import enLocale from 'dayjs/locale/en';

export const dateLocales = {
  bg: bgLocale,
  en: enLocale,
};

export type Locale = keyof typeof dateLocales;
